import type { HTMLAttributes, ReactNode } from 'react'
import { cx } from './cx'
import s from './EmptyState.module.css'

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  action?: ReactNode
}

/** The one "nothing here" placeholder — centered, muted, optional action.
 *
 *  REST PROPS REACH THE ELEMENT (#2406). This used to destructure two props and
 *  drop everything else, so a host's `data-testid` went nowhere — silently,
 *  because a hyphenated JSX attribute is not checked against a component's prop
 *  type. That is load-bearing for the migration off `crm.module.css`'s `.hint`:
 *  the empty states moving here carry testids browser specs locate by
 *  (`lifecycle-none`, `sla-none`, `thread-empty`, `kb-empty`), and every one
 *  would have vanished on adoption with the types and the unit suite green.
 *  `StatTile` shipped exactly that defect and it is fixed there too. */
export function EmptyState({ children, action, className, ...rest }: EmptyStateProps) {
  return (
    <div className={cx(s.empty, className)} {...rest}>
      <div>{children}</div>
      {action && <div className={s.action}>{action}</div>}
    </div>
  )
}
